// extracted by mini-css-extract-plugin
module.exports = {"alert":"VariantDetailMessages_alert__2_sRe","message":"VariantDetailMessages_message__mtGiu","progress":"VariantDetailMessages_progress__2ilc3"};